import { render, staticRenderFns } from "./HeaderMain.vue?vue&type=template&id=630c2288"
import script from "./HeaderMain.vue?vue&type=script&lang=js"
export * from "./HeaderMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports